<template>
  <div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
    <div v-if="!loading">
      <person-form
        v-bind:parentObject="{
          data: this.formData[0],
          searchnew: this.search,
          pageTitle: this.pageTitle,
          pageTitleValue: this.pageTitleValue,
          errMsg: this.errMsg,
          isEdit: this.editMode,
        }"
        v-on:input="formData[0] = $event"
        v-on:new="createHandler"
        v-on:save="saveHandler"
        v-on:delete="isConfirm = !isConfirm"
        v-on:error="errorHandler"
      />

      <div v-if="isErr">
        <app-error
          v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
          }"
          v-on:closeError="isErr = $event"
        />
      </div>

      <div v-if="isConfirm">
        <app-confirm
          v-bind:parentObject="{
            pageTitleValue: this.pageTitleValue,
            isConfirm: this.isConfirm,
          }"
          v-on:confirm="deleteHandler($event)"
          v-on:cancelConfirm="isConfirm = !isConfirm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PersonStatutoryInfo from "../../../components/payroll/personstatutoryinfo/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

//additional line
import ConfirmDialog from "../../../components/common/ConfirmDialog";

import moment from "moment";

export default {
  components: {
    "person-form": PersonStatutoryInfo,
    "app-error": ErrorDialog,

    //additional line
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      search: this.$route.params.search,
      pageTitle: this.$t('setuppersonstatutorynumberinfo.editnewpersonstatutorynumberinfo'),
      pageTitleValue: "",
      formData: {
        psnid: null,
        staffid: null,
        compnyid: null,
        vendorcatid: null,
        refno: null,
        startdate: null,
        enddate: null,
        spouserefno: null,
        spousebranch: null,
        refcodeid: null,
        remark: null,
        stamp: null,

        // additional line
        userid: this.$store.getters.userId,
      },
      errMsg: "",
      isErr: false,
      editMode: true,
      loading: true,

      //additional line
      isConfirm: false,
    };
  },

  methods: {
    deleteHandler($event) {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }
      //add div and change v-on delete
      this.isConfirm = !this.isConfirm;

      //req to delete record
      if ($event) {
        this.$store.dispatch('delete', {url:
              "/personstatutoryinfo/" +
              this.id +
              "/" +
              this.formData[0].userid})
          .then((res) => {
            if (res.data.error) {
              vm.isErr = !vm.isErr;
              vm.errMsg = res.data.error;
            } else {
              this.$router.push({ name: "personstatutoryinfolist" });
            }
          })
          .catch((err) => {
            vm.isErr = !vm.isErr;
            vm.errMsg = err;
          });
      }
    },

    createHandler() {
      this.$router.push({ name: "personstatutoryinfonew" });
    },

    cancelHandler() {
      this.$router.push({ name: "personstatutoryinfolist" });
    },

    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    saveHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }
      var payload = this.formData[0];
      console.log(payload);

      //req to update record
      this.$store.dispatch('put', {url: "/personstatutoryinfo/" + vm.id,
          payload: payload})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "personstatutoryinfolist", params: { search: this.search} });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    //get record by id
    loadPersonStatutoryInfoHandler() {
      const vm = this;

      return this.$store.dispatch('get', {url: "/personstatutoryinfo/" + vm.id})
        .then((res) => {
          if (res.status == 200) {
            vm.formData = res.data.rec;
            vm.pageTitleValue = vm.formData[0].personname;

            //set correct date format using moment
            if (vm.formData[0].startdate) {
              vm.formData[0].startdate = moment(
                vm.formData[0].startdate
              ).format("YYYY-MM-DD");
            }

            if (vm.formData[0].enddate) {
              vm.formData[0].enddate = moment(vm.formData[0].enddate).format(
                "YYYY-MM-DD"
              );
            }

            //additional line
             vm.formData.lockstaff = res.data.rec[0].lockstaff;
            vm.formData[0].userid = this.$store.getters.userId;

            vm.loading = !vm.loading;
          } else {
            vm.isErr = !vm.isErr;
          }
        })
        .catch((err) => {
          vm.isErr = true;
          vm.errMsg = err;
        });
    },
  },

  async mounted() {
    await this.loadPersonStatutoryInfoHandler();
  },
};
</script>
